import gql from 'graphql-tag';
//Used in information block on top
export default gql`
mutation ($args: FA_OrdersOnThisDateInput!){
    fakturaAssist{
    	checkOrdersOnThisDate(args: $args){
	    	orderNr
			userFullName
			dOperation
	 	}
 	}
}`;
